module.exports = function() {
  return new Worker(__webpack_public_path__ + "afa1beaf1d6cc9a900f2.worker.js");
};